import {
  Block,
  LabelMedium,
  Mats,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { ENABLE_MATS_REWARDS_FOR_BORROW } from "#/shared/constants"
import {
  useCalculateMatsForBorrow,
  useCanClaimMatsForNextBorrow,
} from "#/shared/hooks"

export default function BorrowReward() {
  const [css, theme] = useStyletron()
  const { matsForBorrowLabel } = useCalculateMatsForBorrow()
  const { canClaimMatsForBorrow } = useCanClaimMatsForNextBorrow()

  if (!canClaimMatsForBorrow || !ENABLE_MATS_REWARDS_FOR_BORROW) return null

  return (
    <Block
      className={css({
        display: "flex",
        alignItems: "center",
        padding: `${theme.sizing.scale500} ${theme.sizing.scale700}`,
        borderRadius: theme.borders.radius400,
        border: "1px solid",
        borderColor: theme.colors.borderOpaque,
        marginTop: "auto",
      })}
    >
      <ParagraphSmall>Reward</ParagraphSmall>
      <LabelMedium marginLeft="auto" marginRight={theme.sizing.scale700}>
        {matsForBorrowLabel}
      </LabelMedium>
      <Mats size={theme.sizing.scale800} color={theme.colors.accent} />
    </Block>
  )
}
